export default function FlattenerBenefits() {
  const benefits = [
    {
      title: '跨平台兼容',
      description: '支持Windows 64位和Linux 64位系统，满足不同企业的部署需求。',
      icon: 'ri-window-line'
    },
    {
      title: '命令行操作',
      description: '简单的命令行界面，易于集成到现有的自动化工作流和批处理脚本中。',
      icon: 'ri-terminal-box-line'
    },
    {
      title: '批量处理',
      description: '支持批量处理大量PDF表单文件，显著提高文档处理效率。',
      icon: 'ri-stack-line'
    },
    {
      title: '数据安全',
      description: '扁平化后的文档无法被编辑，有效保护表单数据的完整性和安全性。',
      icon: 'ri-shield-check-line'
    },
    {
      title: '一致显示',
      description: '确保扁平化后的文档在所有PDF查看器中保持完全一致的显示效果。',
      icon: 'ri-eye-line'
    },
    {
      title: '技术支持',
      description: '提供专业的技术支持和详细的文档，帮助您快速上手和解决问题。',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            为什么选择PDF Forms Flattener
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            专业的表单扁平化解决方案，为企业提供可靠、高效的PDF表单处理能力
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center">
                    <i className={`${benefit.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">
            需要SDK或其他平台？
          </h3>
          <p className="text-xl mb-8 opacity-90">
            查看Forms Extension，它也支持macOS、Solaris和AIX，或尝试我们的pdfRest API Toolkit Container
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/pdf-forms-extension-sdk" 
              className="inline-flex items-center justify-center bg-white text-teal-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              了解Forms Extension
            </a>
            <a 
              href="/pdf-rest-container" 
              className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              了解pdfRest Container
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
